import { MLBTeam, MLBTeamColour } from "./MLBTeams";
import { NBATeam, NBATeamColour } from "./NBATeams";
import { NFLTeam, NFLTeamColour } from "./NFLTeams";
import { NHLTeam, NHLTeamColour } from "./NHLTeams";

export const TeamMap = new Map<string, string>();
TeamMap.set(NHLTeam.ANAHEIM_DUCKS, NHLTeamColour.ANAHEIM_DUCKS);
TeamMap.set(NHLTeam.ARIZONA_COYOTES, NHLTeamColour.ARIZONA_COYOTES);
TeamMap.set(NHLTeam.BOSTON_BRUINS, NHLTeamColour.BOSTON_BRUINS);
TeamMap.set(NHLTeam.BUFFALO_SABRES, NHLTeamColour.BUFFALO_SABRES);
TeamMap.set(NHLTeam.CALGARY_FLAMES, NHLTeamColour.CALGARY_FLAMES);
TeamMap.set(NHLTeam.CAROLINA_HURRICANES, NHLTeamColour.CAROLINA_HURRICANES);
TeamMap.set(NHLTeam.CHICAGO_BLACKHAWKS, NHLTeamColour.CHICAGO_BLACKHAWKS);
TeamMap.set(NHLTeam.COLORADO_AVALANCHE, NHLTeamColour.COLORADO_AVALANCHE);
TeamMap.set(NHLTeam.COLUMBUS_BLUE_JACKETS, NHLTeamColour.COLUMBUS_BLUE_JACKETS);
TeamMap.set(NHLTeam.DALLAS_STARS, NHLTeamColour.DALLAS_STARS);
TeamMap.set(NHLTeam.DETROIT_RED_WINGS, NHLTeamColour.DETROIT_RED_WINGS);
TeamMap.set(NHLTeam.EDMONTON_OILERS, NHLTeamColour.EDMONTON_OILERS);
TeamMap.set(NHLTeam.FLORIDA_PANTHERS, NHLTeamColour.FLORIDA_PANTHERS);
TeamMap.set(NHLTeam.LOS_ANGELES_KINGS, NHLTeamColour.LOS_ANGELES_KINGS);
TeamMap.set(NHLTeam.MINNESOTA_WILD, NHLTeamColour.MINNESOTA_WILD);
TeamMap.set(NHLTeam.MONTREAL_CANADIENS, NHLTeamColour.MONTREAL_CANADIENS);
TeamMap.set(NHLTeam.NASHVILLE_PREDATORS, NHLTeamColour.NASHVILLE_PREDATORS);
TeamMap.set(NHLTeam.NEW_JERSEY_DEVILS, NHLTeamColour.NEW_JERSEY_DEVILS);
TeamMap.set(NHLTeam.NEW_YORK_ISLANDERS, NHLTeamColour.NEW_YORK_ISLANDERS);
TeamMap.set(NHLTeam.NEW_YORK_RANGERS, NHLTeamColour.NEW_YORK_RANGERS);
TeamMap.set(NHLTeam.OTTAWA_SENATORS, NHLTeamColour.OTTAWA_SENATORS);
TeamMap.set(NHLTeam.PHILADELPHIA_FLYERS, NHLTeamColour.PHILADELPHIA_FLYERS);
TeamMap.set(NHLTeam.PITTSBURGH_PENGUINS, NHLTeamColour.PITTSBURGH_PENGUINS);
TeamMap.set(NHLTeam.ST_LOUIS_BLUES, NHLTeamColour.ST_LOUIS_BLUES);
TeamMap.set(NHLTeam.SAN_JOSE_SHARKS, NHLTeamColour.SAN_JOSE_SHARKS);
TeamMap.set(NHLTeam.SEATTLE_KRAKEN, NHLTeamColour.SEATTLE_KRAKEN);
TeamMap.set(NHLTeam.TAMPA_BAY_LIGHTNING, NHLTeamColour.TAMPA_BAY_LIGHTNING);
TeamMap.set(NHLTeam.TORONTO_MAPLE_LEAFS, NHLTeamColour.TORONTO_MAPLE_LEAFS);
TeamMap.set(NHLTeam.VANCOUVER_CANUCKS, NHLTeamColour.VANCOUVER_CANUCKS);
TeamMap.set(NHLTeam.VEGAS_GOLDEN_KNIGHTS, NHLTeamColour.VEGAS_GOLDEN_KNIGHTS);
TeamMap.set(NHLTeam.WASHINGTON_CAPITALS, NHLTeamColour.WASHINGTON_CAPITALS);
TeamMap.set(NHLTeam.WINNIPEG_JETS, NHLTeamColour.WINNIPEG_JETS);
TeamMap.set(NFLTeam.ARIZONA_CARDINALS, NFLTeamColour.ARIZONA_CARDINALS);
TeamMap.set(NFLTeam.ATLANTA_FALCONS, NFLTeamColour.ATLANTA_FALCONS);
TeamMap.set(NFLTeam.BALTIMORE_RAVENS, NFLTeamColour.BALTIMORE_RAVENS);
TeamMap.set(NFLTeam.BUFFALO_BILLS, NFLTeamColour.BUFFALO_BILLS);
TeamMap.set(NFLTeam.CAROLINA_PANTHERS, NFLTeamColour.CAROLINA_PANTHERS);
TeamMap.set(NFLTeam.CHICAGO_BEARS, NFLTeamColour.CHICAGO_BEARS);
TeamMap.set(NFLTeam.CINCINNATI_BENGALS, NFLTeamColour.CINCINNATI_BENGALS);
TeamMap.set(NFLTeam.CLEVELAND_BROWNS, NFLTeamColour.CLEVELAND_BROWNS);
TeamMap.set(NFLTeam.DALLAS_COWBOYS, NFLTeamColour.DALLAS_COWBOYS);
TeamMap.set(NFLTeam.DENVER_BRONCOS, NFLTeamColour.DENVER_BRONCOS);
TeamMap.set(NFLTeam.DETROIT_LIONS, NFLTeamColour.DETROIT_LIONS);
TeamMap.set(NFLTeam.GREEN_BAY_PACKERS, NFLTeamColour.GREEN_BAY_PACKERS);
TeamMap.set(NFLTeam.HOUSTON_TEXANS, NFLTeamColour.HOUSTON_TEXANS);
TeamMap.set(NFLTeam.INDIANAPOLIS_COLTS, NFLTeamColour.INDIANAPOLIS_COLTS);
TeamMap.set(NFLTeam.JACKSONVILLE_JAGUARS, NFLTeamColour.JACKSONVILLE_JAGUARS);
TeamMap.set(NFLTeam.KANSAS_CITY_CHIEFS, NFLTeamColour.KANSAS_CITY_CHIEFS);
TeamMap.set(NFLTeam.LOS_ANGELES_CHARGERS, NFLTeamColour.LOS_ANGELES_CHARGERS);
TeamMap.set(NFLTeam.LOS_ANGELES_RAMS, NFLTeamColour.LOS_ANGELES_RAMS);
TeamMap.set(NFLTeam.MIAMI_DOLPHINS, NFLTeamColour.MIAMI_DOLPHINS);
TeamMap.set(NFLTeam.MINNESOTA_VIKINGS, NFLTeamColour.MINNESOTA_VIKINGS);
TeamMap.set(NFLTeam.NEW_ENGLAND_PATRIOTS, NFLTeamColour.NEW_ENGLAND_PATRIOTS);
TeamMap.set(NFLTeam.NEW_ORLEANS_SANTS, NFLTeamColour.NEW_ORLEANS_SANTS);
TeamMap.set(NFLTeam.NEW_YORK_GIANTS, NFLTeamColour.NEW_YORK_GIANTS);
TeamMap.set(NFLTeam.NEW_YORK_JETS, NFLTeamColour.NEW_YORK_JETS);
TeamMap.set(NFLTeam.LAS_VEGAS_RAIDERS, NFLTeamColour.OAKLAND_RAIDERS);
TeamMap.set(NFLTeam.PHILADELPHIA_EAGLES, NFLTeamColour.PHILADELPHIA_EAGLES);
TeamMap.set(NFLTeam.PITTSBURGH_STEELERS, NFLTeamColour.PITTSBURGH_STEELERS);
TeamMap.set(NFLTeam.SAN_FRANCISCO_49ERS, NFLTeamColour.SAN_FRANCISCO_49ERS);
TeamMap.set(NFLTeam.SEATTLE_SEAHAWKS, NFLTeamColour.SEATTLE_SEAHAWKS);
TeamMap.set(NFLTeam.TAMPA_BAY_BUCCANEERS, NFLTeamColour.TAMPA_BAY_BUCCANEERS);
TeamMap.set(NFLTeam.TENNESSEE_TITANS, NFLTeamColour.TENNESSEE_TITANS);
TeamMap.set(NFLTeam.WASHINGTON_FB, NFLTeamColour.WASHINGTON_FB);
TeamMap.set(NBATeam.ATLANTA_HAWKS, NBATeamColour.ATLANTA_HAWKS);
TeamMap.set(NBATeam.BOSTON_CELTICS, NBATeamColour.BOSTON_CELTICS);
TeamMap.set(NBATeam.BROOKLYN_NETS, NBATeamColour.BROOKLYN_NETS);
TeamMap.set(NBATeam.CHARLOTTE_HORNETS, NBATeamColour.CHARLOTTE_HORNETS);
TeamMap.set(NBATeam.CHICAGO_BULLS, NBATeamColour.CHICAGO_BULLS);
TeamMap.set(NBATeam.CLEVELAND_CAVALIERS, NBATeamColour.CLEVELAND_CAVALIERS);
TeamMap.set(NBATeam.DALLAS_MAVERICKS, NBATeamColour.DALLAS_MAVERICKS);
TeamMap.set(NBATeam.DENVER_NUGGETS, NBATeamColour.DENVER_NUGGETS);
TeamMap.set(NBATeam.DETROIT_PISTONS, NBATeamColour.DETROIT_PISTONS);
TeamMap.set(NBATeam.GOLDEN_STATE_WARRIORS, NBATeamColour.GOLDEN_STATE_WARRIORS);
TeamMap.set(NBATeam.HOUSTON_ROCKETS, NBATeamColour.HOUSTON_ROCKETS);
TeamMap.set(NBATeam.INDIANA_PACERS, NBATeamColour.INDIANA_PACERS);
TeamMap.set(NBATeam.LOS_ANGELES_CLIPPERS, NBATeamColour.LOS_ANGELES_CLIPPERS);
TeamMap.set(NBATeam.LOS_ANGELES_LAKERS, NBATeamColour.LOS_ANGELES_LAKERS);
TeamMap.set(NBATeam.MEMPHIS_GRIZZLIES, NBATeamColour.MEMPHIS_GRIZZLIES);
TeamMap.set(NBATeam.MIAMI_HEAT, NBATeamColour.MIAMI_HEAT);
TeamMap.set(NBATeam.MILWAUKEE_BUCKS, NBATeamColour.MILWAUKEE_BUCKS);
TeamMap.set(NBATeam.MINNESOTA_TIMBERWOLVES, NBATeamColour.MINNESOTA_TIMBERWOLVES);
TeamMap.set(NBATeam.NEW_ORLEANS_PELICANS, NBATeamColour.NEW_ORLEANS_PELICANS);
TeamMap.set(NBATeam.NEW_YORK_KNICKS, NBATeamColour.NEW_YORK_KNICKS);
TeamMap.set(NBATeam.OKLAHOMA_CITY_THUNDER, NBATeamColour.OKLAHOMA_CITY_THUNDER);
TeamMap.set(NBATeam.ORLANDO_MAGIC, NBATeamColour.ORLANDO_MAGIC);
TeamMap.set(NBATeam.PHILADELPHIA_76ERS, NBATeamColour.PHILADELPHIA_76ERS);
TeamMap.set(NBATeam.PHOENIX_SUNS, NBATeamColour.PHOENIX_SUNS);
TeamMap.set(NBATeam.PORTLAND_TRAIL_BLAZERS, NBATeamColour.PORTLAND_TRAIL_BLAZERS);
TeamMap.set(NBATeam.SACRAMENTO_KINGS, NBATeamColour.SACRAMENTO_KINGS);
TeamMap.set(NBATeam.SAN_ANTONIO_SPURS, NBATeamColour.SAN_ANTONIO_SPURS);
TeamMap.set(NBATeam.TORONTO_RAPTORS, NBATeamColour.TORONTO_RAPTORS);
TeamMap.set(NBATeam.UTAH_JAZZ, NBATeamColour.UTAH_JAZZ);
TeamMap.set(NBATeam.WASHINGTON_WIZARDS, NBATeamColour.WASHINGTON_WIZARDS);
TeamMap.set(MLBTeam.ARIZONA_DIAMONDBACKS, MLBTeamColour.ARIZONA_DIAMONDBACKS);
TeamMap.set(MLBTeam.ATLANTA_BRAVES, MLBTeamColour.ATLANTA_BRAVES);
TeamMap.set(MLBTeam.BALTIMORE_ORIOLES, MLBTeamColour.BALTIMORE_ORIOLES);
TeamMap.set(MLBTeam.BOSTON_RED_SOX, MLBTeamColour.BOSTON_RED_SOX);
TeamMap.set(MLBTeam.CHICAGO_CUBS, MLBTeamColour.CHICAGO_CUBS);
TeamMap.set(MLBTeam.CHICAGO_WHITE_SOX, MLBTeamColour.CHICAGO_WHITE_SOX);
TeamMap.set(MLBTeam.CINCINNATI_REDS, MLBTeamColour.CINCINNATI_REDS);
TeamMap.set(MLBTeam.CLEVELAND_INDIANS, MLBTeamColour.CLEVELAND_INDIANS);
TeamMap.set(MLBTeam.COLORADO_ROCKIES, MLBTeamColour.COLORADO_ROCKIES);
TeamMap.set(MLBTeam.DETROIT_TIGERS, MLBTeamColour.DETROIT_TIGERS);
TeamMap.set(MLBTeam.HOUSTON_ASTROS, MLBTeamColour.HOUSTON_ASTROS);
TeamMap.set(MLBTeam.KANSAS_CITY_ROYALS, MLBTeamColour.KANSAS_CITY_ROYALS);
TeamMap.set(MLBTeam.LOS_ANGELES_ANGELS, MLBTeamColour.LOS_ANGELES_ANGELS);
TeamMap.set(MLBTeam.LOS_ANGELES_DODGERS, MLBTeamColour.LOS_ANGELES_DODGERS);
TeamMap.set(MLBTeam.MIAMI_MARLINS, MLBTeamColour.MIAMI_MARLINS);
TeamMap.set(MLBTeam.MILWAUKEE_BREWERS, MLBTeamColour.MILWAUKEE_BREWERS);
TeamMap.set(MLBTeam.MINNESOTA_TWINS, MLBTeamColour.MINNESOTA_TWINS);
TeamMap.set(MLBTeam.NEW_YORK_METS, MLBTeamColour.NEW_YORK_METS);
TeamMap.set(MLBTeam.NEW_YORK_YANKEES, MLBTeamColour.NEW_YORK_YANKEES);
TeamMap.set(MLBTeam.OAKLAND_ATHLETICS, MLBTeamColour.OAKLAND_ATHLETICS);
TeamMap.set(MLBTeam.PHILADELPHIA_PHILLIES, MLBTeamColour.PHILADELPHIA_PHILLIES);
TeamMap.set(MLBTeam.PITTSBURGH_PIRATES, MLBTeamColour.PITTSBURGH_PIRATES);
TeamMap.set(MLBTeam.ST_LOUIS_CARDINALS, MLBTeamColour.ST_LOUIS_CARDINALS);
TeamMap.set(MLBTeam.SAN_DIEGO_PADRES, MLBTeamColour.SAN_DIEGO_PADRES);
TeamMap.set(MLBTeam.SAN_FRANCISCO_GIANTS, MLBTeamColour.SAN_FRANCISCO_GIANTS);
TeamMap.set(MLBTeam.SEATTLE_MARINERS, MLBTeamColour.SEATTLE_MARINERS);
TeamMap.set(MLBTeam.TAMPA_BAY_RAYS, MLBTeamColour.TAMPA_BAY_RAYS);
TeamMap.set(MLBTeam.TEXAS_RANGERS, MLBTeamColour.TEXAS_RANGERS);
TeamMap.set(MLBTeam.TORONTO_BLUE_JAYS, MLBTeamColour.TORONTO_BLUE_JAYS);
TeamMap.set(MLBTeam.WASHINGTON_NATIONALS, MLBTeamColour.WASHINGTON_NATIONALS);
